/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faUtensilsAlt} from '@fortawesome/pro-duotone-svg-icons';

const FoodServicesIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faUtensilsAlt} {...props} />
);

export default FoodServicesIcon;
